import { FC } from 'react';

import { useRoomCallHandlerPresenter } from './RoomCallHandler.presenter';

export const RoomCallHandler: FC = () => {
  useRoomCallHandlerPresenter();

  return null;
};
